import React from 'react'

import './hamburger.scss'

/**
 * Hamburger menu component for mobile navigation.
 *
 * @param {Function} onClick - The click event handler for the hamburger button.
 * @param {boolean} open - A boolean value indicating whether the menu is open.
 * @returns {JSX.Element} A React component representing the hamburger menu.
 */
export const HamburgerIcon = ({ onClick, open }) => {
  return (
    <button
      onClick={onClick}
      className={`icon-button burger ${open && 'open'}`}
      aria-label={open ? 'Close menu' : 'Open menu'}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" />
        <line className="top" x1="13" y1="11" x2="24" y2="11" />
        <line className="middle" x1="8" y1="16" x2="24" y2="16" />
        <line className="bottom" x1="8" y1="21" x2="24" y2="21" />
      </svg>
    </button>
  )
}
